<div *ngIf='showGlobalLoader'>
    <div class='loader-overlay animate__animated animate__fadeIn'>
        <app-loader-spinner></app-loader-spinner>
    </div>
</div>
